var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.form, "label-width": "160px" }
              },
              [
                _c("p", [
                  _vm._v("包裹点货容错率:(收包数量-包裹点货数量)/收包数量")
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "正负误差(%):", prop: "dabiao_error_range" }
                  },
                  [
                    _c(
                      "el-input",
                      {
                        staticStyle: { width: "90%" },
                        attrs: { type: "number" },
                        model: {
                          value: _vm.form.dabiao_error_range,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dabiao_error_range", $$v)
                          },
                          expression: "form.dabiao_error_range"
                        }
                      },
                      [_c("template", { slot: "append" }, [_vm._v("%")])],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    '\n          包裹点货报错时长:"今日已收完"的商家包裹,提交批次数量不在容错范围内,超时报错\n        '
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "报错时长(分钟)：",
                      prop: "dabiao_limit_time"
                    }
                  },
                  [
                    _c(
                      "el-input",
                      {
                        staticStyle: { width: "90%" },
                        attrs: { type: "number" },
                        model: {
                          value: _vm.form.dabiao_limit_time,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "dabiao_limit_time", $$v)
                          },
                          expression: "form.dabiao_limit_time"
                        }
                      },
                      [_c("template", { slot: "append" }, [_vm._v("分钟")])],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("el-divider"),
            _vm._v(" "),
            _c(
              "el-form",
              { ref: "formQuality", attrs: { model: _vm.formQuality } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "拦截客服的疑似次品商品进行质检",
                      prop: "customer_intercept_defective"
                    }
                  },
                  [
                    _c("el-switch", {
                      attrs: { "active-value": "1", "inactive-value": "2" },
                      model: {
                        value: _vm.formQuality.customer_intercept_defective,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formQuality,
                            "customer_intercept_defective",
                            $$v
                          )
                        },
                        expression: "formQuality.customer_intercept_defective"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "high-value" },
                      [
                        _vm._v(
                          "\n            拦截高单价商品进行质检\n            "
                        ),
                        _c("el-switch", {
                          staticClass: "high-value-switch",
                          attrs: { "active-value": "1", "inactive-value": "2" },
                          model: {
                            value:
                              _vm.formQuality.high_value_intercept_defective,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.formQuality,
                                "high_value_intercept_defective",
                                $$v
                              )
                            },
                            expression:
                              "formQuality.high_value_intercept_defective"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "拦截仓库的质检次品率高的商品进行质检",
                      prop: "storehouse_intercept_defective"
                    }
                  },
                  [
                    _c("el-switch", {
                      attrs: { "active-value": "1", "inactive-value": "2" },
                      model: {
                        value: _vm.formQuality.storehouse_intercept_defective,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formQuality,
                            "storehouse_intercept_defective",
                            $$v
                          )
                        },
                        expression: "formQuality.storehouse_intercept_defective"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "新pc点货时绑定防伪扣",
                      prop: "high_value_bind_safety_buckle"
                    }
                  },
                  [
                    _c("el-switch", {
                      attrs: { "active-value": "1", "inactive-value": "2" },
                      model: {
                        value: _vm.formQuality.high_value_bind_safety_buckle,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.formQuality,
                            "high_value_bind_safety_buckle",
                            $$v
                          )
                        },
                        expression: "formQuality.high_value_bind_safety_buckle"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { "label-width": "160px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleQualitySave }
                      },
                      [_vm._v("\n            保存\n          ")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a126663a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a126663a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/DaBiaoSetting.vue
// module id = null
// module chunks = 